import React, { useEffect, useState } from 'react';
import '../../styles/MarketMarquee.css';

const Stocks = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const res = await fetch(
          'https://stocks.algobook.info/api/v1/stocks?tickers=AAPL,NVDA,MSFT,GOOGL,AMZN,TSLA,META,AMD,INTC,CRM,ADBE,ORCL,CSCO,SNAP,UBER,LYFT,SHOP,ROKU,SQ,PLTR,NFLX,DIS,BA,KO,PEP'
        );
        
        if (!res.ok) throw new Error('API failed');
        
        const data = await res.json();

        const formatted = data.map(stock => {
          const price = typeof stock.lastPrice === 'number' ? stock.lastPrice : null;
          const change = stock.lastClose
            ? ((stock.lastPrice - stock.lastClose) / stock.lastClose * 100).toFixed(2)
            : '0.00';

          return {
            name: stock.name || stock.ticker,
            ticker: stock.ticker,
            price,
            percentChange: change,
          };
        });

        setItems(formatted);
      } catch (err) {
        // Fallback to mock data if API fails
        console.log('Using fallback stock data');
        const mockData = [
          { name: 'Apple Inc.', ticker: 'AAPL', price: 178.72, percentChange: '1.25' },
          { name: 'NVIDIA Corp.', ticker: 'NVDA', price: 875.35, percentChange: '2.45' },
          { name: 'Microsoft Corp.', ticker: 'MSFT', price: 378.91, percentChange: '0.89' },
          { name: 'Alphabet Inc.', ticker: 'GOOGL', price: 141.80, percentChange: '-0.34' },
          { name: 'Amazon.com Inc.', ticker: 'AMZN', price: 178.25, percentChange: '1.12' },
          { name: 'Tesla Inc.', ticker: 'TSLA', price: 248.50, percentChange: '-1.56' },
          { name: 'Meta Platforms', ticker: 'META', price: 505.75, percentChange: '0.78' },
          { name: 'AMD Inc.', ticker: 'AMD', price: 164.46, percentChange: '1.89' },
          { name: 'Intel Corp.', ticker: 'INTC', price: 31.25, percentChange: '-0.45' },
          { name: 'Netflix Inc.', ticker: 'NFLX', price: 628.90, percentChange: '2.11' },
        ];
        setItems(mockData);
      } finally {
        setLoading(false);
      }
    };

    fetchStockData();
  }, []);

  if (loading) {
    return (
      <div className="market-marquee-container">
        <div className="market-marquee-loading">Loading market data...</div>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="market-marquee-container">
        <div className="market-marquee-empty">Market data unavailable</div>
      </div>
    );
  }

  const loopItems = [...items, ...items];

  return (
    <div className="market-marquee-container">
      <div className="market-marquee">
        {loopItems.map((item, index) => (
          <div key={index} className="marquee-card">
            <div className="stock-name">
              {item.name}{' '}
              <span className={parseFloat(item.percentChange) >= 0 ? 'green' : 'red'}>
                ({item.percentChange}%)
              </span>
            </div>
            <div className="stock-price">
              {item.ticker} | {item.price !== null ? `$${item.price.toFixed(2)}` : 'N/A'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stocks;
